<template>
    <body data-sidebar="dark">
      
      <!-- <body data-layout="horizontal" data-topbar="dark"> -->
  
          <!-- Begin page -->
          <div id="layout-wrapper">
  
              
              <!--header-->
              <HeaderComponent />
              <!-- ========== Left Sidebar Start menu ========== -->
            
              <!-- Left Sidebar End -->
  
              <MenuComponent />
  
              <!-- ============================================================== -->
              <!-- Start right Content here -->
              <!-- ============================================================== -->
              <div class="main-content">
  
                  <div class="page-content">
                      <div class="container-fluid">
                        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                          <div class="modal-dialog">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h1 class="modal-title fs-5" id="staticBackdropLabel">Usuario</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div class="modal-body">
                                  
                                 
                                  
                                  
                                  
                                  
                                  <div class="py-1 row">
                                      <div class="col-md-12" style="text-align: left;">
                                          <label  for="telefono" >Folio de Inspección <span class="is-invalid">*</span></label>
                                          <input type="text" class="form-control" v-model="folio_inspeccion" required/>
                                      </div>
                                     
                                  </div>
                                  
                              </div>
                              <div class="modal-footer">
                               
                                <button  type="button" class="btn btn-primary" @click="Inspeccion">Guardar</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      <div class="col-md-4" v-if="formularioscompletados == true">
                         <!-- <div class="col-md-4">-->
                        <h4>Solicitud de inspección para </h4>
                        <button type="button" class="btn btn-dark" data-bs-toggle="modal" data-bs-target="#staticBackdrop" >Empezar proceso de inspección</button>
                      </div>
                        <Tabs >
                           
                            <Tab   title="Generales de la inspección" >
                              
                                <InformacionGeneralComponent />
                             
                            </Tab>
                            <Tab  title="Datos de instalación a inspeccionar">
                                
                                <DatosInstalacion />
                            </Tab>
                            <Tab title="Datos del propietario o representante de la instalación">
                                
                                <DatosPropietario />
                            </Tab>
                            <Tab title="Datos de persona 
                            que atiende la visita">
                                <PersonaAtiendeVisitaComponent />
                              </Tab>
                              <Tab title="Datos del responsable de la instalación para recibir certificado">
                                <PersonaRecibeCertificadoComponent />
                            </Tab>
                            <Tab title="Información general de quien recibe en CFE/CENACE">
                                <ContactoCFEComponent />
                            </Tab>
                            <Tab title="Datos de facturación">
                              <FacturacionComponent />
                          </Tab>
                            <Tab title="Datos de Testigos">
                              <TestigosComponent />
                          </Tab>
                          
                          </Tabs>
  
                      </div> <!-- container-fluid -->
                  </div>
                  <!-- End Page-content -->
                  <FooterComponent/>
                  <!--<footer class="footer">
                      <div class="container-fluid">
                          <div class="row">
                              <div class="col-sm-6">
                                 
                              </div>
                              <div class="col-sm-6">
                                  <div class="text-sm-end d-none d-sm-block">
                                      Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesdesign
                                  </div>
                              </div>
                          </div>
                      </div>
                  </footer>-->
                  
              </div>
              <!-- end main content-->
  
          </div>
          <!-- END layout-wrapper -->
  
          <!-- Right Sidebar -->
          <div class="right-bar">
              <div data-simplebar class="h-100">
                  <div class="rightbar-title d-flex align-items-center px-3 py-4">
              
                      <h5 class="m-0 me-2">Settings</h5>
  
                      <a href="javascript:void(0);" class="right-bar-toggle ms-auto">
                          <i class="mdi mdi-close noti-icon"></i>
                      </a>
                  </div>
  
                  <!-- Settings -->
                  <hr class="mt-0" />
                  <h6 class="text-center mb-0">Choose Layouts</h6>
  
                  <div class="p-4">
                      <div class="mb-2">
                          <img src="assets/images/layouts/layout-1.png" class="img-thumbnail" alt="layout-1">
                      </div>
  
                      <div class="form-check form-switch mb-3">
                          <input class="form-check-input theme-choice" type="checkbox" id="light-mode-switch" checked>
                          <label class="form-check-label" for="light-mode-switch">Light Mode</label>
                      </div>
      
                      <div class="mb-2">
                          <img src="assets/images/layouts/layout-2.png" class="img-thumbnail" alt="layout-2">
                      </div>
                      <div class="form-check form-switch mb-3">
                          <input class="form-check-input theme-choice" type="checkbox" id="dark-mode-switch" data-bsStyle="assets/css/bootstrap-dark.min.css" data-appStyle="assets/css/app-dark.min.css">
                          <label class="form-check-label" for="dark-mode-switch">Dark Mode</label>
                      </div>
      
                      <div class="mb-2">
                          <img src="assets/images/layouts/layout-3.png" class="img-thumbnail" alt="layout-3">
                      </div>
                      <div class="form-check form-switch mb-5">
                          <input class="form-check-input theme-choice" type="checkbox" id="rtl-mode-switch" data-appStyle="assets/css/app-rtl.min.css">
                          <label class="form-check-label" for="rtl-mode-switch">RTL Mode</label>
                      </div>
  
              
                  </div>
  
              </div> <!-- end slimscroll-menu-->
          </div>
          <!-- /Right-bar -->
  
      
  
      </body>
  </template>
  <script>
  
  import MenuComponent from '@/components/MenuComponent.vue'
  import HeaderComponent from '@/components/HeaderComponent.vue'
  import InformacionGeneralComponent from '@/components/InformacionGeneralComponent.vue'
  import DatosInstalacion from '@/components/DatosInstalacion.vue'
  import DatosPropietario from '@/components/DatosPropietarioRepresentanteComponent.vue'
  import PersonaAtiendeVisitaComponent from '@/components/PersonaAtiendeVisitaComponent.vue'
  import PersonaRecibeCertificadoComponent from '@/components/PersonaRecibeCertificadoComponent.vue'
  import ContactoCFEComponent from '@/components/ContactoCFEComponent.vue'
  import TestigosComponent from '@/components/TestigosComponent.vue'
  import FacturacionComponent from '@/components/FacturacionComponent.vue'



  import Tabs from '@/components/Tabs.vue';
  import Tab from '@/components/Tab.vue';
  import FooterComponent from '@/components/FooterComponent.vue'
  import axios from 'axios';
    import Swal from 'sweetalert2';
  export default {
    name: 'HomeView',
    data() {
        return {
            formularios:[],
            formularioscompletados:''
        }
    },
    components: {
      MenuComponent,
      HeaderComponent,
      FooterComponent,
      Tabs,
      Tab,
      InformacionGeneralComponent,
      DatosInstalacion,
      DatosPropietario,
      PersonaAtiendeVisitaComponent,
      PersonaRecibeCertificadoComponent,
      ContactoCFEComponent,
      TestigosComponent,
      FacturacionComponent
    },
    mounted() {
        this.consultarFormulario();
        this.consultarFormulariosCompletados();
    },
    methods: {
      Inspeccion(){
            if(this.folio_inspeccion > ' '){
                var idcotizacion = localStorage.getItem('idcotizacion');
                axios.post(this.$rutaServer+'procesoInspeccion', { idcotizacion: idcotizacion,folio_inspeccion:this.folio_inspeccion })
                .then(response => {
                    if (response.status == 200) {
                      Swal.fire('Exito!', 'Folio de Inspeccion generado', 'success');
                    }
                })
                .catch(error => {
                    //Swal.fire('¡Error!', 'Ocurrió un error', 'error');
                });
            }
            else{
                    Swal.fire('¡Error!', 'El folio no debe ser vacio', 'error');
            }
        },
        consultarFormulario() {
        var idcotizacion = localStorage.getItem('idcotizacion');
        axios.post(this.$rutaServer+'formularios', { idcotizacion: idcotizacion })
          .then(response => {
            if (response.status == 200) {
              this.formularios = response.data;
              
            }
          })
          .catch(error => {
            //Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
      },
      consultarFormulariosCompletados() {
        //alert('aqui');
        var idcotizacion = localStorage.getItem('idcotizacion');
        axios.post(this.$rutaServer+'formulariosCompletados', { idcotizacion: idcotizacion })
          .then(response => {
            if (response.status == 200) {
              this.formularioscompletados = response.data.formulariosCompletados;
              
            }
          })
          .catch(error => {
            //Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
      },
     /* getTabTitle(form) {
      let title = '';
      if (form.idformulario === 1) {
        title = 'Datos generales';
      } else if (form.idformulario === 2) {
        title = 'Datos de instalación';
        title += form.estatus === 'Pendiente' ? '<span class="circle"></span>' : '<span class="circlecolor"></span>';
      } else if (form.idformulario === 3) {
        title = 'Datos del propietario o representante legal';
      }
      return title;
    },*/
    getComponent(idformulario) {
      switch (idformulario) {
        case 1:
          return 'InformacionGeneralComponent';
        case 2:
          return 'DatosInstalacion';
        case 3:
          return 'DatosPropietario';
        default:
          return null;
      }
    },
}
  }
  </script>
  <style>
  .circle {
    width: 12px;
    height: 12px;
    background-color: red;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .circlecolor {
    width: 12px;
    height: 12px;
    background-color: green;
    border-radius: 50%;
    margin-right: 10px;
  }
</style>



